// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__LgVh8","options":"AnswerScale_options__2oXCH","selected":"AnswerScale_selected__jBuv2"};